import { useMutation } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { queryClient } from '@/main.tsx';

const useLogout = () => {
  const mutationFn = async () => {
    return logout();
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export default useLogout;

async function logout(): Promise<void> {
  try {
    await BackendClient.post<BackendSuccessResponse<{ id: string }>>('/api/auth/logout');

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while logging out.');
  }
}
